import { Box, Flex, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useState } from 'react';

import { TextBold, TextRegular } from 'UiKit/typography';
import InputTextAreaComponent from 'UiKit/input-textarea';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { reasonModalText } from 'Const/monitoring/view';

import styles from './styles.module.css';
import { Condition } from 'Component/others';

const HelpPartnerReasonModal = ({ isOpen, monitoringStatus, onSend }) => {
  const [notes, setNotes] = useState('');
  const [error, setError] = useState(null);

  const isDisabledButton = notes?.trimEnd().length < 20;

  const onSubmit = () => onSend({ monitoringStatus, notes });

  return (
    <Modal isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent maxWidth="600px">
        <Box className={styles['help-partner-reason__modal']}>
          <Box className={styles['help-partner-reason__section--head']}>
            <TextBold className={styles['title__text']}>{reasonModalText.titleText}</TextBold>
          </Box>

          <Box className={styles['help-partner-reason__section--content']}>
            <Flex className={styles['textarea__container--head']}>
              <TextBold className={styles['subtitle__text']}>{reasonModalText.textAreaLabel}</TextBold>
              <TextRegular className={styles['textarea-count__text']}>({notes?.length}/100)</TextRegular>
            </Flex>
            <InputTextAreaComponent
              value={notes}
              className={styles['text-area__container']}
              placeholder={reasonModalText.textAreaPlaceholder}
              onChange={(e) => {
                const value = e.target.value
                  .trimStart()
                  .replace('  ', ' ')
                  .replace(/[^a-zA-Z0-9 ]/g, '');
                if (value.trimEnd().length > 19) setError(null);
                setNotes(value);
              }}
              maxLength={100}
              onBlur={() => {
                const validNotes = notes.trimEnd();
                if (validNotes.length < 20) {
                  setError({
                    message: validNotes?.length !== notes?.length ? reasonModalText.errorNotValidText : reasonModalText.errorText,
                  });
                } else {
                  setError(null);
                }
              }}
              error={error}
            />
            <Condition statement={!error}>
              <TextRegular className={styles['text-area__description--text']}>{reasonModalText.descriptionText}</TextRegular>
            </Condition>
          </Box>
          <Box className={styles['help-partner-reason__section--footer']}>
            <ButtonSolid className={styles['send__button']} disabled={isDisabledButton} onClick={onSubmit}>
              {reasonModalText.buttonText}
            </ButtonSolid>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default HelpPartnerReasonModal;
